import { render, staticRenderFns } from "./create-ctc.vue?vue&type=template&id=8eac1a42&"
import script from "./create-ctc.vue?vue&type=script&lang=js&"
export * from "./create-ctc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports